export default __webpack_public_path__ + "static/media/dnv_updapt.eaf809dd.jpg";